import React from 'react';
import '../../App.css';
import './Header.css';
const Header = () => (
  <header>
    <nav>
      <span className="navigation-header-logo-header"></span>
      <h2 className='ml-2'>Welcome to the TP AI Recruitment Demo</h2>
    </nav>
  </header>
);

export default Header;